import React from 'react';
import { Typography } from 'antd';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './styles.module.less';
const { Text, Title } = Typography;

const AuthTitleText = ({ title, text, classNameText }) => (
  <>
    <Title level={3} className={styles.authTitleTextHeader}>
      {title}
    </Title>
    <Text className={clsx(styles.authTitleTextSubHeader, classNameText)}>
      {text}
    </Text>
  </>
);

AuthTitleText.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  classNameText: PropTypes.string,
};

export default AuthTitleText;
